jQuery(document).ready(function($) {
    const $calculator = $('.js-calculator');
	calculator($, $calculator);
});

function calculator($, $calculator) {
    $calculator.on('submit', function (e) {

        e.preventDefault();

        const $result = $calculator.find('.js-result');
        const $total = $calculator.find('.js-total');
        const $submit = $calculator.find('[type="submit"]');

        const pagesNumber = $calculator.find('#pages').val();
        const paperTypeMultiplier = $calculator.find('#paper-type option:selected').val();
        const paperTickness = $calculator.find('#paper-tickness option:selected').val();
        const interiorTotalTickness = pagesNumber / 2 * paperTickness * paperTypeMultiplier / 1000;

        const coverPaperTypeMultiplier = $calculator.find('#cover-paper-type option:selected').val();
        const coverPaperTickness = $calculator.find('#cover-paper-tickness option:selected').val();
        const coverTotalTickness = coverPaperTypeMultiplier * coverPaperTickness / 1000 * 2;
        
        const totalTickness = interiorTotalTickness + coverTotalTickness;

        const formatedTotalTickness = calculatorFormLocalizedData.recalculate != 'en' ? totalTickness.toFixed(2).toString().replace('.', ',') : totalTickness;
        $total.html(formatedTotalTickness + 'mm');
        $submit.html(calculatorFormLocalizedData.recalculate);
        $result.addClass('active');

    });
}